export enum ClientTypesEnum {
    Individual = 1,
    Corporate
}
